export const LOCAL_TYPE = 1;
export const ONLINE_TYPE = 0;
